import { render } from "./Cmor.vue?vue&type=template&id=cb51b208&scoped=true"
import script from "./Cmor.vue?vue&type=script&lang=js"
export * from "./Cmor.vue?vue&type=script&lang=js"

import "./Cmor.vue?vue&type=style&index=0&id=cb51b208&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb51b208"]])

export default __exports__